import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.title,
      "width": 800
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('add-subject-form', _vm._g(_vm._b({
    ref: "addSubjectFormRef",
    attrs: {
      "data": _vm.data
    }
  }, 'add-subject-form', _vm.$attrs, false), _vm.$listeners)), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "welcome_add_subject_cancel",
      "id": "welcome_add_subject_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "welcome_add_subject_save",
      "id": "welcome_add_subject_save",
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };